import { type AxiosError, HttpStatusCode, isAxiosError, isCancel } from "axios";
import { SendToTrackingService } from "@/api/handlers/errors";

/**
 * SWR の onError コールバック用エラーハンドラ。
 * リクエストキャンセルを除外し、500以上のステータスコードで SendToTrackingService を呼び出す。
 */
export const swrErrorHandler = (err: AxiosError): void => {
  if (err.code === "ERR_CANCELED") return;
  if (
    (err.response?.status ?? HttpStatusCode.InternalServerError) >=
    HttpStatusCode.InternalServerError
  ) {
    SendToTrackingService(err);
  }
};

/**
 * mutation API の catch ブロック用エラーハンドラ。
 * 500以上のステータスコードで SendToTrackingService を呼び出し、元のエラーを re-throw する。
 */
export const handleMutationError = (error: unknown): never => {
  if (
    !isCancel(error) &&
    isAxiosError(error) &&
    (error.response?.status ?? HttpStatusCode.InternalServerError) >=
      HttpStatusCode.InternalServerError
  ) {
    SendToTrackingService(error);
  }
  throw error;
};
